module.exports = __webpack_public_path__ + "img/20220225150655166v2m.034b32a0.jpg";